import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Container, List, ListItem, SuccessMessage, WarningMessage } from './styles'

const PasswordStrength = ({ value, statusRules }) => {
  const [hasLowerCase, setHasLowerCase] = useState(false)
  const [hasUppercase, setHasUppercase] = useState(false)
  const [hasNumber, setHasNumber] = useState(false)
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState(false)
  const [minLength, setMinLength] = useState(false)

  const rulesValidator = {
    validateLowercase: value => {
      ;/[a-z]/.test(value) ? setHasLowerCase(true) : setHasLowerCase(false)
    },
    validateUppercase: value => {
      ;/[A-Z]/.test(value) ? setHasUppercase(true) : setHasUppercase(false)
    },
    validateNumber: value => {
      ;/[0-9]/.test(value) ? setHasNumber(true) : setHasNumber(false)
    },
    validateSymbol: value => {
      ;/[!"#£$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value) ? setHasSpecialCharacter(true) : setHasSpecialCharacter(false)
    },
    validateMinLength: value => {
      value?.length >= 8 ? setMinLength(true) : setMinLength(false)
    },
  }

  const checkRules = value => {
    rulesValidator.validateLowercase(value)
    rulesValidator.validateUppercase(value)
    rulesValidator.validateNumber(value)
    rulesValidator.validateSymbol(value)
    rulesValidator.validateMinLength(value)
  }

  useEffect(() => {
    checkRules(value)
  }, [value])

  return (
    <Container>
      {hasLowerCase && hasUppercase && hasNumber && hasSpecialCharacter && minLength ? statusRules(true) : statusRules(false)}
      {hasLowerCase && hasUppercase && hasNumber && hasSpecialCharacter && minLength ? (
        <SuccessMessage>Sua senha atende todos os itens de segurança.</SuccessMessage>
      ) : (
        <WarningMessage>Sua senha deve conter:</WarningMessage>
      )}
      <List>
        {!hasLowerCase && <ListItem>letras minúsculas</ListItem>}
        {!hasUppercase && <ListItem>letras maiúsculas</ListItem>}
        {!hasNumber && <ListItem>números</ListItem>}
        {!hasSpecialCharacter && <ListItem>caracteres especiais</ListItem>}
        {!minLength && <ListItem>mínimo 8 dígitos</ListItem>}
      </List>
    </Container>
  )
}

PasswordStrength.propTypes = {
  value: PropTypes.string.isRequired,
  statusRules: PropTypes.func,
}
PasswordStrength.displayName = 'PasswordStrength'

export default PasswordStrength
